module.exports = __webpack_public_path__ + "static/media/resumeBlog1.acb35c0d.png";